import { render, staticRenderFns } from "./pay_setting_switch.vue?vue&type=template&id=7be45487&"
import script from "./pay_setting_switch.vue?vue&type=script&lang=js&"
export * from "./pay_setting_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports